<div class="panel">
  <h2>Autorisation</h2>

  <div class="form-group">
    <label>Administrateur</label>
    <t-option [(value)]="user.is_admin"></t-option>
  </div>
</div>